import './Header.css'

const Header = () => {
  return (
    <div>
      <div className="residenceheader">
        <p>RESIDENCES</p>
      </div>
    </div>
  )
}

export default Header